<div class="result">
	<h2> YOUR PAYMENT IS BEING PROCESSED </h2>
	<mat-icon>currency_exchange</mat-icon>
	<p>
		You will soon receive an email to the previously given address, specifying whether it has
		been accepted or rejected. <br>
		Please use the navigation bars to exit from this page.
	</p>
</div>